

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.Fw1cuuSB.js","_app/immutable/chunks/scheduler.11LYO-93.js","_app/immutable/chunks/index.v-pHvQc9.js"];
export const stylesheets = ["_app/immutable/assets/0.06miQx6k.css"];
export const fonts = [];
